const oko = () => {
    window.addEventListener('load', function() {
        document.querySelectorAll('.oko-control-label').forEach(function(label) {
            label.textContent = '';
        });
    // Получены все input`ы (4 с модалки и 4 с футера), присвоены плейсхолдеры из массива
        const placeholders = ['Ваше имя:', 'Телефон:', 'E-mail:', 'Сообщение:', 'Ваше имя:', 'Телефон:', 'E-mail:', 'Сообщение:'];
        document.querySelectorAll('.oko-form-control').forEach(function(input, index) {
            input.setAttribute('placeholder', placeholders[index]);
        });


        let modal = document.querySelector('#modal-feedback');
        let submitButton = modal.querySelectorAll('.custom-fields-form-button359');

        if (modal && submitButton) {
            console.log('Найдено');
            submitButton[1].addEventListener('click', function() {
                modal.close();
            });
        }
    });
}
export default oko;

// let observer = new MutationObserver(function(mutations) {
//     mutations.forEach(function(mutation) {
//         if (mutation.type === 'characterData') {

//             document.querySelectorAll('.oko-control-label').forEach(function(label) {
//                 label.textContent = '';
//             });
//         // Получены все input`ы (4 с модалки и 4 с футера), присвоены плейсхолдеры из массива
//             const placeholders = ['Ваше имя:', 'Телефон:', 'E-mail:', 'Сообщение:', 'Ваше имя:', 'Телефон:', 'E-mail:', 'Сообщение:'];
//             document.querySelectorAll('.oko-form-control').forEach(function(input, index) {
//                 input.setAttribute('placeholder', placeholders[index]);
//             });
//         }
//     });
// });

// const form = document.querySelector('oko-control-label');

// // конфигурация наблюдателя
// // var config = { childList: true, subtree: true };

// // передаем элемент и конфигурацию в наблюдатель
// observer.observe(form, { characterData: true, subtree: true });

    